import { ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { PatientPortalServiceSelect } from './PatientPortalServiceSelect';
import { ReceptionServiceSelect } from './ReceptionServiceSelect';
import {
   HealthcareProviderPatientPortalBoundServiceCreateFormBean,
   HealthcareProviderPatientPortalBoundServiceCreateFormController,
} from './healthcareProviderPatientPortalBoundServiceCreate.types';

type HealthcareProviderPatientPortalBoundServiceCreateFormChildrenRendererProps = {
   handleSubmit: HealthcareProviderPatientPortalBoundServiceCreateFormController['handleSubmit'];
   formState: HealthcareProviderPatientPortalBoundServiceCreateFormController['formState'];
};

type HealthcareProviderPatientPortalBoundServiceCreateFormProps = {
   readonly children: (
      childrenProps: HealthcareProviderPatientPortalBoundServiceCreateFormChildrenRendererProps
   ) => ReactElement;
};

export const HealthcareProviderPatientPortalBoundServiceCreateForm = (
   props: HealthcareProviderPatientPortalBoundServiceCreateFormProps
): ReactElement => {
   const {
      register,
      handleSubmit,
      formState,
   } = useFormController<HealthcareProviderPatientPortalBoundServiceCreateFormBean>({});

   return (
      <StyledFlex as={'form'} direction={'column'} gap={'20px'} noValidate>
         <PatientPortalServiceSelect register={register} />
         <ReceptionServiceSelect register={register} />
         {props.children({ handleSubmit: handleSubmit, formState: formState })}
      </StyledFlex>
   );
};
